import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Box,
  Pagination,
} from "@mui/material";

const InventoryTable = ({
  rows = [],
  page,
  total,
  pageSize,
  selectedRows,
  setSelectedRows,
  onPageChange,
}) => {
  //------------------------------------------
  // Select All
  //------------------------------------------

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(rows.map((item) => item.id));
    } else {
      setSelectedRows([]);
    }
  };

  //------------------------------------------
  // Single Select
  //------------------------------------------

  const handleSelect = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(
        selectedRows.filter((item) => item !== id)
      );
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  //------------------------------------------

  const totalPages = Math.ceil(total / pageSize);

  //------------------------------------------

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 600,
          border: "1px solid #ddd",
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={
                    rows.length > 0 &&
                    selectedRows.length === rows.length
                  }
                  indeterminate={
                    selectedRows.length > 0 &&
                    selectedRows.length < rows.length
                  }
                  onChange={handleSelectAll}
                />
              </TableCell>

              <TableCell><b>ID</b></TableCell>
              <TableCell><b>UID</b></TableCell>
              <TableCell><b>IMEI</b></TableCell>
              <TableCell><b>ICCID Primary</b></TableCell>
              <TableCell><b>ICCID Secondary</b></TableCell>
              <TableCell><b>Basket</b></TableCell>
              <TableCell><b>Status</b></TableCell>
              <TableCell><b>Bootstrap Activation Request</b></TableCell>
              <TableCell><b>Bootstrap Activation Status</b></TableCell>
              <TableCell><b>Commercial Activation Request</b></TableCell>
              <TableCell><b>Commercial Activation Status</b></TableCell>
              <TableCell><b>Plan</b></TableCell>
              <TableCell><b>Provider</b></TableCell>
              <TableCell><b>MSISDN</b></TableCell>
              <TableCell><b>Upload Time</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={12}
                  align="center"
                >
                  <Typography
                    sx={{
                      py: 5,
                      color: "gray",
                    }}
                  >
                    No Inventory Available
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow
                  hover
                  key={row.id}
                  selected={selectedRows.includes(row.id)}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() =>
                        handleSelect(row.id)
                      }
                    />
                  </TableCell>

                  <TableCell>{row.id}</TableCell>

                  <TableCell>{row.uid}</TableCell>

                  <TableCell>{row.imei}</TableCell>

                  <TableCell>
                    {row.iccid_primary}
                  </TableCell>

                  <TableCell>
                    {row.iccid_secondary}
                  </TableCell>

                  <TableCell>
                    {row.basket_name}
                  </TableCell>

                  <TableCell>
                    {row.provider_sim_status}
                  </TableCell>
            <TableCell>
  {row.bootstrap_activation_request == null
    ? ""
    : String(row.bootstrap_activation_request)}
</TableCell>

<TableCell>
  {row.bootstrap_activation_status == null
    ? ""
    : String(row.bootstrap_activation_status)}
</TableCell>

<TableCell>
  {row.commercial_activation_requested == null
    ? ""
    : String(row.commercial_activation_requested)}
</TableCell>

<TableCell>
  {row.commercial_activation_status == null
    ? ""
    : String(row.commercial_activation_status)}
</TableCell>

                  <TableCell>
                    {row.plan_name}
                  </TableCell>

                  <TableCell>
                    {row.telecom_provider_primary}
                  </TableCell>

                  <TableCell>
                    {row.msisdn_primary}
                  </TableCell>

                  <TableCell>
                    {row.esim_upload_time
                      ? new Date(
                          row.esim_upload_time
                        ).toLocaleString()
                      : "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            page={page}
            count={totalPages}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default InventoryTable;